<template>
  <filtertron-tray-section
    v-if="field.type !== 'file'"
    id="field-configurator-data-protection"
    :title="lang.get('fields.configuration.data_protection.label')"
    :initially-collapsed="true"
  >
    <div class="fields island">
      <div class="form-group">
        <div
          v-for="protectionType in protectionTypes"
          :key="protectionType"
          class="radio styled"
        >
          <input
            :id="protectionType"
            :disabled="field.isRecalculating"
            type="radio"
            name="protection"
            :checked="field.protection === protectionType"
            @change="onProtectionChange(protectionType)"
          />
          <label :for="protectionType">
            {{ lang.get(`fields.form.protection.${protectionType}`) }}
          </label>
        </div>
        <span>
          <a
            :href="protectionGuideUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ lang.get('fields.form.protection.about') }}
          </a>
        </span>
      </div>
    </div>
  </filtertron-tray-section>
</template>

<script>
import { mapState } from 'vuex';
import FiltertronTraySection from '@/lib/components/Filtertron/FiltertronTraySection';
import handleInputMixin from '../handle-input-mixin.js';

export default {
  inject: ['lang'],
  components: {
    FiltertronTraySection
  },
  mixins: [handleInputMixin],
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      fieldSearchable: null
    };
  },
  computed: {
    ...mapState('entryForm', ['protectionGuideUrl', 'protectionTypes'])
  },
  methods: {
    onProtectionChange(protectionType) {
      const payload = {
        protection: protectionType
      };

      if (protectionType === 'maximum') {
        this.fieldSearchable = this.field.searchable;
        payload['searchable'] = false;
      } else if (
        this.field.protection === 'maximum' &&
        this.fieldSearchable !== null
      ) {
        payload['searchable'] = this.fieldSearchable;
      }

      this.$emit('input', payload);
    }
  }
};
</script>
